"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterTextCaseInsensitive = void 0;
const filterTextCaseInsensitive = (a, b) => a.toLowerCase().includes(b.toLowerCase());
exports.filterTextCaseInsensitive = filterTextCaseInsensitive;
